const totalDeptList = []

const cardInfo =[]

const saveCashOut =[]

export default{
  totalDeptList,
  cardInfo,
  saveCashOut
}


// WEBPACK FOOTER //
// ./src/store/state.js